const updateVariantImages = (selectedOptions, variantsData, optionNames) => {
  const optionInputEls = document.querySelectorAll('input[data-variant-input]');
  if (!optionInputEls.length) return;
  const optionEls = [...new Set([...optionInputEls].map(i => i.name))];

  const getImageSrc = (src) => {
    if (!src) return src;
    if (src.startsWith('//')) return window.location.protocol + src;
    if (src.startsWith('/')) return window.location.origin + src;
    return src;
  };

  const getImageUrl = (src, width) => {
    const url = new URL(src);
    if (width) url.searchParams.set('width', width);
    return url.toString();
  };

  const getSrcsetWidths = (srcset) => srcset
    .split(',')
    .map(candidate => candidate.trim().match(/\s(\d+)w$/)?.[1])
    .filter(Boolean);

  const updateImageSrcset = (imageEl, src) => {
    if (!imageEl.hasAttribute('srcset')) return;

    const widths = getSrcsetWidths(imageEl.getAttribute('srcset'));
    if (!widths.length) return;

    const srcset = widths
      .map(width => `${getImageUrl(src, width)} ${width}w`)
      .join(', ');

    imageEl.setAttribute('srcset', srcset);
  };

  optionEls.forEach((optionName) => {
    const optionInput = document.querySelector(`input[name="${optionName}"]`);
    if (!optionInput) return;
    const optionContainerEl = optionInput.closest('li');
    if (!optionContainerEl) return;

    const optionLabelEls = optionContainerEl.querySelectorAll('[data-variant-label]');
    if (!optionLabelEls.length) return;

    optionLabelEls.forEach((label) => {
      const inputEl = label.control || document.querySelector(`#${label.htmlFor}`);
      if (!inputEl) return;

      const optionValue = inputEl.value;
      const currentOptions = { ...selectedOptions, [optionName]: optionValue };

      const matchingVariant = variantsData.find(variant =>
        optionNames.every((optionName, index) => {
          const selectedValue = currentOptions[optionName];
          const variantValue = variant[`option${index + 1}`];
          return String(selectedValue) === String(variantValue);
        })
      );

      if (!matchingVariant) return;

      const imageURL = matchingVariant.featured_image?.src;
      if (!imageURL) return;
      const formattedImageURL = getImageSrc(imageURL);
      const imageEl = label.querySelector('[data-variant-image]');
      if (imageEl) {
        imageEl.setAttribute('src', getImageUrl(formattedImageURL, imageEl.getAttribute('width')));
        updateImageSrcset(imageEl, formattedImageURL);
        if (matchingVariant.featured_image?.alt) imageEl.setAttribute('alt', matchingVariant.featured_image.alt);
      }
    });
  });
};

export default updateVariantImages;
